import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import icon0 from '../../assets/img/optimize/icon0.png';
import icon1 from '../../assets/img/optimize/icon1.png';
import icon2 from '../../assets/img/optimize/icon2.png';
import icon3 from '../../assets/img/optimize/icon3.png';

const OptimizeSection = () => {
  const ndaItems = [
    { id: 1, text: "100% NDA-protected Contract", icon: icon0, offset: 0 },
    { id: 2, text: "Dedicated Resource Hiring", icon: icon1, offset: 40 },
    { id: 3, text: "Flexible Hiring Models", icon: icon2, offset: 40 },
    { id: 4, text: "Risk-Free Trials", icon: icon3, offset: 0 }
  ];

  return (
    <section className="optimize-wrapper">
      <div className="optimize-inner">
        <div className="optimize-left">
          <h2 className="optimize-title">
            Optimize Your Construction Projects with Expertise, Scan to BIM Conversion, and Architectural Services
          </h2>
          <p className="optimize-text">
            Schedule a call with our dedicated BIM team. We'll guide you through the process, highlight the benefits of BIM for your construction projects, and help you every step of the way to ensure the best outcome.
          </p>
          <button className="optimize-btn">
            Let's Discuss <ArrowUpRight size={14} />
          </button>
        </div>
        <div className="optimize-right">
          {ndaItems.map((item) => (
            <div
              key={item.id}
              className={`nda-pill pill-offset-${item.offset}`}
            >
              <div className="nda-icon">
                <img
                  src={item.icon.src || item.icon}
                  alt={item.text}
                  width="50"
                  height="50"
                  style={{ objectFit: 'contain' }}
                />
              </div>
              {item.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OptimizeSection;
